'use strict';

const { jsPDF } = require('jspdf');

const WRAPPER_JS_CLASS = '.js-download-eula-wrapper';
const LINK_JS_CLASS = '.js-download-eula-link';
const CHECKBOX_JS_CLASS = '.js-download-eula-checkbox';
const POINTER_EVENTS_NONE_CLASS = 'pe-none';
const INVISIBLE_CLASS = 'invisible';
const PLACEHOLDER_JS_CLASS = '.js-placeholder';
const EULA_CONTENT_JS_CLASS = '.js-eula-content';

function createEULAAsPDF(eulaWrapper) {
    try {
        const eulaElement = eulaWrapper?.querySelector(EULA_CONTENT_JS_CLASS);

        if (!eulaElement) {
            return;
        }
        // eslint-disable-next-line new-cap
        const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
        doc.setFontSize(12);

        const text = (eulaElement.textContent || eulaElement.innerText).trim();
        const lines = doc.splitTextToSize(text, 180);

        const pageHeight = doc.internal.pageSize.getHeight();
        const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
        const marginTop = 20;
        const marginBottom = 15;
        let y = marginTop;

        lines.forEach(line => {
            if (y + lineHeight > pageHeight - marginBottom) {
                doc.addPage();
                y = marginTop;
            }
            doc.text(line, 14, y);
            y += lineHeight;
        });

        doc.save(eulaElement.dataset.fileName + '_' + Date.now());
    } catch (error) {
        console.error('Error in createEULAAsPDF:', error);
    }
}

function handleEULADownload(event) {
    const wrapper = event.target.closest(WRAPPER_JS_CLASS);
    const checkbox = wrapper?.querySelector(CHECKBOX_JS_CLASS);
    const link = wrapper?.querySelector(LINK_JS_CLASS);

    if (!wrapper || !link || !checkbox) {
        return;
    }

    if (!checkbox.checked) {
        if (event.type === 'click') {
            event.preventDefault();
        }
        link.classList.add('text-muted');
        checkbox.classList.add('is-invalid');
    } else {
        checkbox.classList.remove('is-invalid');
        link.classList.remove('text-muted');
    }
}

function updateUIWithLoadedState(wrapper) {
    wrapper.querySelectorAll(`.${INVISIBLE_CLASS}`).forEach(elem => {
        elem.classList.remove(INVISIBLE_CLASS);
    });
    wrapper.querySelector(PLACEHOLDER_JS_CLASS)?.remove();
}

function initDownloadsEULALogic() {
    document.querySelectorAll('.js-pdf-link').forEach(eulaPdfLink => {
        eulaPdfLink.addEventListener('click', function (event) {
            try {
                const clickedLink = event.currentTarget;
                const eulaWrapper = clickedLink?.closest('.js-download-section')?.querySelector(WRAPPER_JS_CLASS);

                if (!eulaWrapper) {
                    return;
                }

                createEULAAsPDF(eulaWrapper);
            } catch (error) {
                console.error('Error in handleEulaButtonClick:', error);
            }
        });
    });

    document.querySelectorAll(WRAPPER_JS_CLASS).forEach(wrapper => {
        updateUIWithLoadedState(wrapper);

        const checkbox = wrapper.querySelector(CHECKBOX_JS_CLASS);
        checkbox?.addEventListener('change', (event) => {
            handleEULADownload(event);
        });

        const link = wrapper.querySelector(LINK_JS_CLASS);
        link?.classList.remove(POINTER_EVENTS_NONE_CLASS);
        link?.addEventListener('click', (event) => {
            handleEULADownload(event);
        });
    });
}

module.exports = function () {
    initDownloadsEULALogic();
};
